import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { I18nProvider } from '@fiverr-private/fiverr_context';
import { FilterProvider } from '../../context/filterContext';
import { buildServiceOptionTitle } from '../../../service/customFilters';
import {
    filterNavigation,
    shouldFilterNavigate
} from '../../../service/clientNavigation';
import {
    TOP_GROUPING
} from '../../../config/filters';
import SubCategoriesFilter from '../../search/search_header/SubCategoriesFilter';
import { BI_SOURCES, FILTERS_LOCATION } from '../../../utils/constants';
import { AppContext } from '../../context/listingsContext';
import FilterGroup from './menus/FilterGroup';
import { FILTER_MENU_CONTENT_MAPPING } from './menus/consts';
import FloatingMenu from './menus/FloatingMenu';
import './index.scss';
import './menus/content/index.scss';
import StickyBar from './sticky_bar';
import ToggleFilters from './menus/content/toggleFilters';

const filterAndSort = (filters, groupingKey) =>
    filters
        .filter(({ topGrouping }) => topGrouping === groupingKey)
        .sort((a, b) => a.order - b.order);

const getFilterDisplay = (filter, activeFilters) => {
    const isActive = activeFilters[filter.id] !== undefined;

    return { title: filter.alias, active: isActive };
};

const FloatingTopBar = (props) => {
    const { currency } = useContext(AppContext);
    const {
        filters,
        selectedFilters,
        activeFilters,
        subCategory,
        noGigs,
        fromSearchFlow = false
    } = props;

    const { serviceOptionKey, service } = buildServiceOptionTitle(subCategory);
    const additionalProps = { currencySymbol: currency.symbol };

    const serviceFilters = filterAndSort(filters, TOP_GROUPING.SERVICE);
    const sellerFilters = filterAndSort(filters, TOP_GROUPING.SELLER);
    const singleFilters = filterAndSort(filters, TOP_GROUPING.BUDGET).concat(
        filterAndSort(filters, TOP_GROUPING.DELIVERY_TIME)
    );

    const applyFilters = (
        change,
        active,
        location = FILTERS_LOCATION.FLOATING_TOP,
        source = BI_SOURCES.DROPDOWN_FILTERS
    ) => filterNavigation(change, active, location, source);

    return (
        <FilterProvider activeFilters={activeFilters}
            navigationCondition={shouldFilterNavigate}
            applyNavigation={applyFilters}>
            <StickyBar>
                <div className="top-filters">
                    {!noGigs && fromSearchFlow && (
                        <SubCategoriesFilter data={subCategory}/>
                    )}
                    <I18nProvider>
                        {({ i18n }) => (
                            <React.Fragment>
                                <FilterGroup filters={serviceFilters}
                                    title={i18n.t(serviceOptionKey, {
                                        service
                                    })}
                                    activeFilters={activeFilters}
                                    navigationCondition={
                                        shouldFilterNavigate
                                    }
                                    applyNavigation={applyFilters}/>

                                <FilterGroup filters={sellerFilters}
                                    title={i18n.t(
                                        'search_perseus.filter.seller'
                                    )}
                                    activeFilters={activeFilters}
                                    navigationCondition={
                                        shouldFilterNavigate
                                    }
                                    applyNavigation={applyFilters}/>
                            </React.Fragment>
                        )}
                    </I18nProvider>
                    {singleFilters.map((filter) => (
                        <FloatingMenu key={filter.id}
                            id={filter.id}
                            menuTitle={filter.alias}
                            data={filter.options}
                            activeFilters={activeFilters}
                            additionalProps={additionalProps}
                            {...getFilterDisplay(
                                filter,
                                activeFilters,
                                selectedFilters
                            )}
                            contentType={
                                FILTER_MENU_CONTENT_MAPPING[
                                    filter.display_type
                                ]
                            }
                            navigationCondition={shouldFilterNavigate}
                            applyNavigation={applyFilters}
                            trackOpen/>
                    ))}
                </div>
                {!noGigs && <ToggleFilters filters={filters}/> }
            </StickyBar>
        </FilterProvider>
    );
};

FloatingTopBar.propTypes = {
    filters: PropTypes.array.isRequired
};

export default FloatingTopBar;
